import axios from "axios";
import { Base_URL } from "../url";

export const saveReconciliationDocument = async (
  reconciliationData,
  userName
) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Reconciliation_Document`,
      reconciliationData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving reconciliation document!";
  }
};

export const updateReconciliationStatus = async (workingDaysId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Reconciliation_Cockpit/UpdateReconciliationStatus`,
      null, // No request body, only query param
      {
        params: { workingDaysId },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating reconciliation status!";
  }
};

// ✅ GET API to fetch reconciliation data
export const getReconciliationData = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/Reconciliation_Document/ReconciliationGetData`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching reconciliation data!";
  }
};

// ✅ GET API to fetch document type data
export const getDocumentTypeData = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/Reconciliation_Document/DocumentTypeGetData`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching document type data!";
  }
};

// ✅ POST API to save document type data
export const saveDocumentType = async (documentTypeData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Reconciliation_Document/Bank_Reco_DocType`,
      documentTypeData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving document type!";
  }
};

// ✅ POST API to insert ACHD data
export const insertAchd = async (achdData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Reconciliation_Document/Stpl_Transfer`,
      achdData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error inserting ACHD data!";
  }
};

// ✅ GET API to fetch reconciliation document type data
export const getRecoDocTypeData = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/Reconciliation_Document/Reco_DocTypeGetData`
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data ||
      "Error fetching reconciliation document type data!"
    );
  }
};

// ✅ POST API for manual bank reconciliation
export const manualBankReconciliation = async (manualRecoData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Reconciliation_Document/PaymentBankReco`,
      manualRecoData
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || "Error performing manual bank reconciliation!"
    );
  }
};

// ✅ GET API to fetch personal expense data
export const getPersonalExpenseData = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/Reconciliation_Document/PersonalExpenseGetData`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching personal expense data!";
  }
};

// ✅ POST API for personal reconciliation
export const personalReconciliation = async (personalReconciliationData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Reconciliation_Document/PersonalReconciliation`,
      personalReconciliationData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error performing personal reconciliation!";
  }
};

// ✅ GET API to search reconciliation document by head1
export const searchReconciliationDocument = async (head1) => {
  try {
    const response = await axios.get(
      `${Base_URL}/Reconciliation_Document/search/${head1}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error searching reconciliation document!";
  }
};


export const getDocumentTypes = async () => {
  const res = await axios.get(
    `${Base_URL}/Reconciliation_Document/DocumentTypeGetData`
  );
  return res.data;
};
export const getOpenInvoices = async (customerCode, organisationId) => {
  const res = await axios.get(
    `${Base_URL}/Invoices/GetOpenInvoices/${customerCode}/${organisationId}`
  );
  return res.data;
};
export const createSettlement = async (payload) => {
  const res = await axios.post(
    `${Base_URL}/Reconciliation_Document/CreateSettleMent`,
    payload
  );
  return res.data;
};
export const getCustomerByIdAndOrg = async (customerCode, organisationId) => {
  const res = await axios.get(
    `${Base_URL}/CurrencyMaster/GetCustomerByIdAndOrg/${customerCode}/${organisationId}`
  );
  return res.data;
};

export const createSettlementNo = async (payload) => {
  const res = await axios.post(
    `${Base_URL}/Reconciliation_Document/CreateSettleMentNo`,
    payload
  );
  return res.data;
};
export const getClientsByStatementAndDocType = async (
  statementId,
  documentType
) => {
  const res = await axios.get(
    `${Base_URL}/Reconciliation_Document/GetClients`,
    {
      params: {
        statementId,
        documentType,
      },
    }
  );
  return res.data;
};